



















































































import Vue from "vue";
import EventCalendar from "./components/manage/EventCalendar.vue";
import VueRouter from "vue-router";
import LogoList from "./components/manage/LogoList.vue";
import LoginVue from "./components/manage/Login.vue";
import RoomListVue from "./components/manage/RoomList.vue";
import EventTableVue from "./components/manage/EventTable.vue";
import URLListVue from "./components/urls/URLList.vue";
import { UserInfo } from "./interfaces";
import { getProfile } from "./services";
import HomeVue from "./components/manage/Home.vue";
import Donations from "./components/manage/Donations.vue";

Vue.use(VueRouter);
const routes = [
  { path: "/", component: HomeVue, name: 'home' },
  { path: "/events", component: EventTableVue, name: 'eventTable' },
  { path: "/calendar", component: EventCalendar, name: 'eventCalendar' },
  { path: "/logos", component: LogoList, name: 'eventLogos' },
  { path: "/login", component: LoginVue, name: 'login' },
  { path: "/rooms", component: RoomListVue, name: 'eventRooms' },
  { path: "/urls", component: URLListVue, name: 'urls' },
  { path: '/donations', component: Donations, name: 'donations' },
];

// 3. Create the router instance and pass the `routes` option
// You can pass in additional options here, but let's
// keep it simple for now.
const router = new VueRouter({
  routes, // short for `routes: routes`
});
router.beforeEach(async (to, from, next) => {
  if (to.name === 'home' || to.name === 'login') {
    next();
    return;
  }
  const profile = await getProfile();
  if (!profile) {
    next('/');
    return;
  }
  if (profile.isAdmin) {
    next();
    return;
  } else if (to.name === 'urls') {
    if (profile.groups.includes('urls')) {
      next();
      return;
    }
  } else if (profile.profile.organisation) {
    next();
    return;
  }
  next('/');
})
export default Vue.extend({
  name: "App",
  router,
  components: {},

  data: () => ({
    drawer: true,
    userInfo: undefined as UserInfo | undefined
  }),
  async created() {
    this.userInfo = await getProfile();
  }
});
